import { useField } from "formik"
import { cloneDeep } from "lodash"
import { InputTextarea } from "primereact/inputtextarea"
import { useEffect } from "react"

const FormikTextArea = ({
  id,
  placeholder,
  autoFocus,
  onChange,
  className,
  disabled = false,
  noSpaces = false,
  ...props
}: $TSMigrationFixMe) => {
  const [field, meta] = useField(props)

  useEffect(() => {
    const el = document.querySelector(`input[name="${props.name}"]`)
    el?.setAttribute("autocomplete", "nope")
  }, [props.name])
  const errorMsg = meta.error && meta.touched ? meta.error : ""

  const handleInputText = (e: $TSMigrationFixMe) => {
    const newEvent = cloneDeep(e)

    if (noSpaces) {
      newEvent.target.value = newEvent.target.value.replace(" ", "")
    }

    if (onChange) {
      return onChange(newEvent)
    }

    return field.onChange(newEvent)
  }

  return (
    <>
      <InputTextarea
        rows={5}
        cols={10}
        autoResize
        id={id}
        disabled={disabled}
        placeholder={placeholder}
        autoFocus={autoFocus}
        className={`${className} ${errorMsg ? "p-invalid p-d-block" : ""}`}
        autoComplete='nope'
        // @ts-expect-error TS(2783): 'value' is specified more than once, so this usage...
        value={field.value || ""}
        // @ts-expect-error TS(2783): 'onChange' is specified more than once, so this us...
        onChange={handleInputText}
        {...field}
      />
      {errorMsg && <small className='p-error p-d-block'>{errorMsg}</small>}
    </>
  )
}

export default FormikTextArea
